import { useEffect, useState } from 'react'
import { checkReady } from 'common/services/intercom'

export function useIntercomReady() {
  const [isReady, setIsReady] = useState(false)

  useEffect(() => {
    let retries = 0
    const maxRetries = 20 // we ensure that the interval stops in case Intercom doesn't load

    if (checkReady()) {
      setIsReady(true)
      return
    }

    const interval = setInterval(() => {
      if (checkReady()) {
        clearInterval(interval)
        setIsReady(true)
      } else if (++retries >= maxRetries) {
        clearInterval(interval)
      }
    }, 500)

    return () => clearInterval(interval)
  }, [])

  return isReady
}
